import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  max-width: 1312px;
  height: 100%;
  margin: 0 auto;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

export const FooterPage = styled.footer`
  background: ${props => props.theme.lightGrey};
  padding: 3rem 0rem;

  @media (max-width: 768px) {
    padding: 2rem 0rem;
  }

  h3 {
    color: ${props => props.theme.primaryColor};
    padding-bottom: 1.25rem;
    padding-bottom: 1.25rem;
    padding-left: 0.3rem;
  }

  ul {
    display: flex;
  }

  li {
    padding: 0.3rem 0;
    color: ${props => props.theme.textColor};
    transition: all 0.3s ease-in-out;

    &:hover {
      font-weight: bold;
      color: ${props => props.theme.secondaryColor};
    }
  }
  a {
    display: flex;
    color: ${props => props.theme.textColor};
    &:hover {
      font-weight: bold;
      color: ${props => props.theme.secondaryColor};
    }
  }

  hr {
    width: 95%;
    margin: 0 auto;
  }
`;

export const FooterIcon = styled.div`
  padding: 0.3rem 0;
`;
export const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #c4c4c4;
  margin: 2rem 0rem;
`;
